import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { SignupuserService } from '../../../services/signupuser.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../services/auth.service';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
  imports: [FormsModule, CommonModule, NgxSpinnerModule],
  providers: [NgxSpinnerModule],
  standalone:true

})
export class ChangePasswordComponent {
  emailaddress: string | undefined;
  authCode: string | undefined;
  password: any;
  confirmPassword: any;
  passwordStatus: boolean = false;
  showEmailErr: boolean = false;
  showEmailMsg: any;
  showLinkExpiredMsg: boolean=false;

  constructor(
    private router: ActivatedRoute,
    private route: Router,
    private userService: SignupuserService,
    private spinner: NgxSpinnerService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.authService.checkAuthAndRedirectHome();
    this.router.queryParams.subscribe(params => {
      this.emailaddress = params['email'];
      this.authCode = params['auth'];
    });
  }
  changePassword() {
    this.spinner.show()
    if (this.confirmPassword.length > 0) {
      let changePasswordParams = {
          Website: "ssp",
          Email: this.emailaddress,
          MobileToken: "",
          WebToken: this.authCode,
          Password: this.confirmPassword
      }
      this.userService.changePassword(changePasswordParams).subscribe((res: any) => {
        if (res && res.Status.toLowerCase() === 'success') {
          this.passwordStatus = true;
          //this.route.navigateByUrl('/log-in')
          this.spinner.hide()
        } else if (res && res.Status === 'Invalid user') {
          this.spinner.hide()
          this.showEmailErr = true;
          this.showEmailMsg = "This is not an active Storen account. Please activate the account first before trying to update the password.";
        }
        else if (res && res.Status.includes("Email link expired")) {
          this.spinner.hide() 
          this.showLinkExpiredMsg = true;
        } else if(res && res.Status.includes("password:")){
          this.spinner.hide() 
          this.showEmailErr = true;
          this.showEmailMsg = "The password you entered is too common and may be easily guessed. Please choose a stronger, less predictable password.";
        }
        else {
          this.spinner.hide();
          this.showEmailErr = true;
          this.showEmailMsg = "Oops! Something went wrong. Please try again later.";
        }
      });
    }
  }
  redirectToLogin() {
    this.route.navigateByUrl('/log-in');
  }
}
